import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, FlexProps, Typography } from 'antd';
import cn from 'classnames';

import { EOfferRateTypes, IActualRate, OfferLine, OfferSection } from 'entities/Offer';
import { useMeta } from 'shared/hooks';

import styles from './OfferRates.module.scss';

interface IOfferRatesProps extends Omit<FlexProps, 'children'> {
	actualRates: IActualRate[] | null;
	sign: string;
}

export const OfferRates: FC<IOfferRatesProps> = ({ actualRates, className, sign, ...props }) => {
	const { t } = useTranslation();
	const [selectedSource, setSelectedSource] = useState<string | null>(null);
	const { sourcesMap, sourcesIsFetching } = useMeta();

	if (!actualRates?.length) return null;

	return (
		<OfferSection {...props} header={t('Ставки за целевые действия')} className={cn(styles.rates, className)}>
			<Flex vertical gap={8}>
				{!sourcesIsFetching && actualRates.length > 1 && (
					<Flex vertical gap={4}>
						<Typography.Text type="secondary">
							{t('Если площадки нет в списке, для неё действуют базовые ставки:')}
						</Typography.Text>
						<Flex gap={4}>
							{actualRates.map(({ source_id }) => (
								<button
									key={source_id}
									className={cn(styles.button, { [styles.active]: source_id === selectedSource })}
									onClick={() => setSelectedSource(source_id)}>
									{source_id ? sourcesMap?.[source_id]?.name || source_id : t('Общие тарифы')}
								</button>
							))}
						</Flex>
					</Flex>
				)}
				<div>
					{actualRates
						.find(({ source_id }) => source_id === selectedSource)
						?.rates.map((rate) => (
							<OfferLine
								key={rate.name}
								label={rate.name + (rate.description ? ` (${rate.description})` : '')}
								value={`${rate.payout_size} ${rate.type === EOfferRateTypes.PERCENT ? '%' : sign}`}
							/>
						))}
				</div>{' '}
			</Flex>
		</OfferSection>
	);
};
